import { ActionSection } from '@/components/actions/ActionContent';
import ResponsibleList from '@/components/actions/ResponsibleList';
const ActionResponsiblePartiesBlock = props => {
  const {
    block,
    responsibleParties
  } = props;
  return <ActionSection data-sentry-element="ActionSection" data-sentry-component="ActionResponsiblePartiesBlock" data-sentry-source-file="ActionResponsiblePartiesBlock.tsx">
      <ResponsibleList heading={block?.heading} responsibleParties={responsibleParties} data-sentry-element="ResponsibleList" data-sentry-source-file="ActionResponsiblePartiesBlock.tsx" />
    </ActionSection>;
};
export default ActionResponsiblePartiesBlock;